export enum PaySessionSplitType {
	//One participant pays everything
	FULL = 'full',
	//Every participant chooses his items
	SEPARATE = 'separate',
	//Every participant pays equally
	EQUAL = 'equal',
}
